import {DataStatus} from 'platform/components';
import {Box} from 'platform/foundation';

import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {isNotNil} from 'ramda';

import {useGetVehicleQuery} from '@dms/api/sales';
import {
  getCustomTenantCatalogue,
  getVehicleMakeModels,
  selectCarAudit,
  useThunkDispatch,
} from '@dms/teas';

import {useRequiredParams} from 'shared/web';

import type {EagGridMaximization} from 'features/eag-grid';

import {VehicleDocuments} from './components/VehicleDocuments';

interface DocumentsProps {
  maximization?: EagGridMaximization;
}

export const Documents = (props: DocumentsProps) => {
  const dispatch = useThunkDispatch();

  const {id: vehicleId} = useRequiredParams();
  const {data: vehicle} = useGetVehicleQuery({vehicleId});

  const {loading} = useSelector(selectCarAudit);
  const isAuditLoading = loading['vehicleCatalogue/getCustomTenantCatalogue'];

  useEffect(
    function loadVehicleCatalogues() {
      if (isNotNil(vehicleId) && isNotNil(vehicle) && !isAuditLoading) {
        Promise.all([
          dispatch(
            getVehicleMakeModels.action({
              vehicleType: vehicle.type!,
              make: vehicle.make,
            })
          ),
          dispatch(getCustomTenantCatalogue.action({})),
        ]);
      }
    },
    [vehicle, vehicleId] // eslint-disable-line react/exhaustive-deps -- Muted pre-existing violation
  );

  return (
    <Box flex={1} minWidth={0}>
      <DataStatus isLoading={isAuditLoading} minHeight={100}>
        <VehicleDocuments maximization={props.maximization} />
      </DataStatus>
    </Box>
  );
};
